export default __webpack_public_path__ + "static/media/opening03.8a402e9a.jpg";